import Diversity2Icon from '@mui/icons-material/Diversity2';

import { configureChains, createConfig, useAccount, useConnect, useDisconnect, useNetwork, useSwitchNetwork } from 'wagmi'

import { polygonMumbai } from 'wagmi/chains'
import { useWeb3Modal } from "@web3modal/react";
import { InjectedConnector } from 'wagmi/connectors/injected'
import { useEffect, useState } from 'react';

export default function Header() {
  const { disconnect } = useDisconnect()
  const { setDefaultChain } = useWeb3Modal();
  const { chain } = useNetwork()

  const { connect } = useConnect({
    connector: new InjectedConnector(),
  })

  const { address, isConnected } = useAccount()
  const [Accounts, setAccounts] = useState(null)

  setDefaultChain(polygonMumbai);
  const { switchNetworkAsync } = useSwitchNetwork({
    chainId: 80001
  })

  async function disconnectwallet() {
    localStorage.removeItem('wagmi.injected.shimDisconnect')
    window.localStorage.clear()
    window.dispatchEvent(new Event("storage"));
    setAccounts()
  }
  useEffect(() => {
    setAccounts(address)
  }, [address])


  console.log(address);


  return (<>
    <header>

      <div className="container mx-auto flex justify-between py-4 px-4 sm:px-0">
        <a href={"/"}>
          <h1 className="flex cursor-pointer items-center font-extrabold">
            <span className="pl-2 text-xl sm:pl-4 sm:text-2xl text-white">
              <Diversity2Icon style={{ marginBottom: '3px' }} /> ArtChainAuction
            </span>
          </h1>
        </a>
        {address &&
          <>

            {chain.id !== 80001 && <li onClick={() => {
              switchNetworkAsync?.().then(() => { }).catch(() => { })
            }} style={{ backgroundColor: "#bc4242", padding: "10px", borderRadius: "20px", cursor: "pointer" }}>
              Wrong Network
            </li>}
          </>
        }

        {!Accounts &&
          <button className="btn" type="button" onClick={() => {
            connect()
            localStorage.setItem('wagmi.injected.shimDisconnect', true)
          }}>
            <strong>Connect Wallet</strong>
            <div id="container-stars">
              <div id="stars"></div>
            </div>
            <div id="glow">
              <div class="circles"></div>
              <div class="circles"></div>
            </div>
          </button>}
        {Accounts && <>
          <h2 style={{ color: 'white' }}>Wallet Address - {Accounts && <> {Accounts.substring(0, 3)} ... {Accounts.slice(-3)}</>}</h2>
        </>}
        {Accounts &&
          <button className="btn" type="button" onClick={() => {
            disconnectwallet()
            disconnect()
          }}>
            <strong>Disconnect Wallet</strong>
            <div id="container-stars">
              <div id="stars"></div>
            </div>

            <div id="glow">
              <div class="circles"></div>
              <div class="circles"></div>
            </div>
          </button>}
        {/* <button
                className="max-w-[120px] truncate  rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 py-2 px-5 text-white hover:opacity-80 sm:max-w-[200px]"
              >
                {"Connect MetaMask"}
              </button> */}
      </div>
    </header>

  </>)
}